<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="success"
        size="mini"
        @click="getDate()"
        >刷新</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      >
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px">UID</label>
        <el-input
          v-model="uid"
          placeholder="请输入uid"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">账号 </label>
        <el-input
          v-model="username"
          placeholder="请输入账号"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <!-- <div class="item_warp">
        <label style="margin: 0 10px">VIP等级</label>
        <el-input
          v-model="vipStr"
          placeholder="多个等级#号隔开"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div> -->
      <div class="item_warp">
        <label style="margin: 0 10px">上级UID</label>
        <el-input
          v-model="parentUid"
          placeholder="请输入上级UID"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">ip</label>
        <el-input
          v-model="ip"
          placeholder="请输入ip"
          style="width: 110px"
          size="mini"
          clearable
        />
      </div>

      <div class="item_warp">
        <label style="margin: 0 10px">地区/国家</label>
        <el-input
          v-model="ipAddress"
          placeholder="请输入地区/国家"
          style="width: 110px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">下级团队 ></label>
        <el-input
          v-model="minChildCount"
          placeholder="请输入下级团队"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">乙方</label>
        <el-input
          v-model="yifangUsername"
          placeholder="请输入乙方"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      
      <div class="item_warp">
        <label style="margin: 0 10px">业务员</label>
        <el-select v-model="isYewu" style="width: 100px" placeholder="请选择" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">充值用户</label>
        <el-select v-model="isRecharge" style="width: 100px" placeholder="请选择" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">账号状态</label>
        <el-select v-model="isEnabled" style="width: 100px" placeholder="请选择" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option label="启用" value="true"></el-option>
          <el-option label="禁用" value="false"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <el-checkbox v-model="isLock">登录锁定</el-checkbox>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">老用户</label>
        <el-select
          v-model="platformMemo"
          style="width: 100px"
          placeholder="请选择"
          clearable
        >
          <el-option label="不限" value=""></el-option>
          <el-option label="全部充值" value="allRecharge"></el-option>
          <el-option label="全部" value="all"></el-option>
          <el-option label="MD" value="MD"></el-option>
          <el-option label="BAM" value="BAM"></el-option>
          <el-option label="HR" value="HR"></el-option>
          <el-option label="ADAS" value="ADAS"></el-option>
          <el-option label="HH" value="HH"></el-option>
          <el-option label="EG" value="EG"></el-option>
          <el-option label="XBK" value="XBK"></el-option>
          <el-option label="XPET" value="XPET"></el-option>
           <el-option label="ZOO" value="ZOO"></el-option>
          <el-option label="MM" value="MM"></el-option>
          <el-option label="FS" value="FS"></el-option>
        </el-select>
      </div>
      <!-- <div class="item_warp">
        <label style="margin: 0 10px">累计奖励 ></label>
        <el-input
          v-model="minTotalAward"
          placeholder="请输入累计奖励"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div> -->
      <!-- <div class="item_warp">
        <el-checkbox v-model="etw">非VIP可提2U</el-checkbox>
      </div> -->
      <div class="item_warp">
        <label style="margin: 0 10px">注册时间</label>
        <el-date-picker
          v-model="dataTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          style="margin-right: 10px;flex:1;"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1931px"
      size="mini"
    >
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <div>
             <div style="margin-bottom: 5px;">
                <el-button
                type="primary"
                class="edit-button"
                style="width:70px;"
                size="mini"
                @click="getSetIsEnabled(scope.row)"
                >编辑</el-button
              >
             </div>
             <div style="margin-bottom: 5px;">
                <el-button
                type="primary"
                class="edit-button"
                size="mini"
                @click="getChong(scope.row)"
                >手动充值</el-button
              >
             </div>
             <div>
                <el-button
                type="primary"
                class="edit-button"
                size="mini"
                @click="getZiJin(scope.row)"
                >资金明细</el-button
              >
             </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="UID" width="100">
        <template slot-scope="scope">
          <div>
           <div>
              {{scope.row.uid}}
            </div>
            <div v-if="scope.row.isYewu" style="color: #ff0000">
              业务员
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="账号" width="100" />
      <el-table-column prop="address" label="下级总数" width="100">
         <template #header>
            <div class="flex">
              <span class="gbRed">下级总数</span>
              <img @click="selectOrder('下级总数','asc')" v-if="childrenCount == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('下级总数','')" v-if="childrenCount == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('下级总数','desc')" v-if="childrenCount == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
        <template slot-scope="scope">
          <div>
            {{ scope.row.childrenCount }}
            <div>
              <el-button
                type="primary"
                class="edit-button"
                size="mini"
                @click="getChildrenSum(scope.row)"
                >详情</el-button
              >
              <!-- <el-button
                type="primary"
                class="edit-button"
                size="mini"
                @click="toTree(scope.row)"
                >下级树</el-button
              > -->
              
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="最后登录IP" width="200">
        <template slot-scope="scope">
          <div>
            <div>{{ scope.row.lastIp }}</div>
            <div>{{ scope.row.lastIpAddress }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="memo" label="备注" width="100" />
      <el-table-column prop="ipCount" label="IP重复数" width="100" />
      
      <!-- <el-table-column prop="address" label="VIP等级" width="100">
        <template slot-scope="scope">
          <div>
            VIP{{ scope.row.vipLevel }}
            <span v-if="scope.row.isLockVip" style="color:red">已锁定</span>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="realAirdropBuyAmount" label="算力包金额" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">算力包金额</span>
              <img @click="selectOrder('算力包金额','asc')" v-if="realAirdropBuyAmount == 'desc'" style="width:20px;cursor: pointer;" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('算力包金额','')" v-if="realAirdropBuyAmount == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('算力包金额','desc')" v-if="realAirdropBuyAmount == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      
      <el-table-column prop="totalProfit" label="算力包金额" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计总收益</span>
              <img @click="selectOrder('累计总收益','asc')" v-if="totalProfit == 'desc'" style="width:20px;cursor: pointer;" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累计总收益','')" v-if="totalProfit == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累计总收益','desc')" v-if="totalProfit == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <el-table-column prop="realAirdropWaitSaleAmount" label="解锁中ai金额" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">解锁中ai金额</span>
              <img @click="selectOrder('解锁中ai金额','asc')" v-if="realAirdropWaitSaleAmount == 'desc'" style="width:20px;cursor: pointer;" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('解锁中ai金额','')" v-if="realAirdropWaitSaleAmount == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('解锁中ai金额','desc')" v-if="realAirdropWaitSaleAmount == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <!-- <el-table-column prop="amount" label="余额" width="100" /> -->
      <el-table-column prop="amount" align="center" width="110">
        <template #header>
            <div class="flex">
              <span class="gbRed">USDT余额</span>
              <img @click="selectOrder('余额','asc')" v-if="amountOrder == 'desc'" style="width:20px;cursor: pointer;" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('余额','')" v-if="amountOrder == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('余额','desc')" v-if="amountOrder == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <!-- <el-table-column prop="amountTrx" label="TRX余额" width="100">
        <template #header>
            <div class="flex">
              <span class="gbRed">TRX余额</span>
              <img @click="selectOrder('TRX余额','asc')" v-if="amountTrxOrder == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('TRX余额','')" v-if="amountTrxOrder == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('TRX余额','desc')" v-if="amountTrxOrder == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column> -->
      <!-- <el-table-column prop="canWithdrawAmount" label="可提现额度U" width="110" /> -->
      <!-- <el-table-column prop="canWithdrawAmountTrx" label="可提现额度T" width="110" /> -->

      <!-- <el-table-column prop="canWithdrawAmount" label="可提现额度U" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">可提现额度U</span>
              <img @click="selectOrder('可提现额度U','asc')" v-if="canWithdrawAmount == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('可提现额度U','')" v-if="canWithdrawAmount == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('可提现额度U','desc')" v-if="canWithdrawAmount == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <el-table-column prop="afterTradeWithdrawAmount" label="需要交易额U" width="130" />
      <el-table-column prop="canWithdrawAmountTrx" label="可提现额度T" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">可提现额度T</span>
              <img @click="selectOrder('可提现额度T','asc')" v-if="canWithdrawAmountTrx == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('可提现额度T','')" v-if="canWithdrawAmountTrx == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('可提现额度T','desc')" v-if="canWithdrawAmountTrx == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
       <el-table-column prop="afterTradeWithdrawAmountTrx" label="需要交易额T" width="130" /> -->
       <!-- 1 -->
       <!-- <el-table-column prop="totalIntelAmount" label="EXDog余额" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">EXDog余额</span>
              <img @click="selectOrder('EXDog余额','asc')" v-if="totalIntelAmount == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('EXDog余额','')" v-if="totalIntelAmount == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('EXDog余额','desc')" v-if="totalIntelAmount == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
       <el-table-column prop="totalIntelProfit" label="EXDOG收益" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">EXDOG收益</span>
              <img @click="selectOrder('EXDOG收益','asc')" v-if="totalIntelProfit == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('EXDOG收益','')" v-if="totalIntelProfit == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('EXDOG收益','desc')" v-if="totalIntelProfit == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column> -->
       <!-- <el-table-column prop="totalInvestBuyAmountReal2" label="简单赚币U" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">简单赚币U</span>
              <img @click="selectOrder('简单赚币U','asc')" v-if="totalInvestBuyAmountReal2 == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('简单赚币U','')" v-if="totalInvestBuyAmountReal2 == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('简单赚币U','desc')" v-if="totalInvestBuyAmountReal2 == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column> -->
       <!-- <el-table-column prop="totalInvestBuyAmountRealTrx2" label="简单赚币T" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">简单赚币T</span>
              <img @click="selectOrder('简单赚币T','asc')" v-if="totalInvestBuyAmountRealTrx2 == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('简单赚币T','')" v-if="totalInvestBuyAmountRealTrx2 == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('简单赚币T','desc')" v-if="totalInvestBuyAmountRealTrx2 == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column> -->
       <!-- <el-table-column prop="totalTradeBuy" label="现货购买U" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">现货购买U</span>
              <img @click="selectOrder('现货购买U','asc')" v-if="totalTradeBuy == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('现货购买U','')" v-if="totalTradeBuy == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('现货购买U','desc')" v-if="totalTradeBuy == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
       <el-table-column prop="totalTradeProfit" label="现货收益U" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">现货收益U</span>
              <img @click="selectOrder('现货收益U','asc')" v-if="totalTradeProfit == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('现货收益U','')" v-if="totalTradeProfit == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('现货收益U','desc')" v-if="totalTradeProfit == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column> -->
       <!-- <el-table-column prop="totalTradeBuyTrx" label="现货购买T" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">现货购买T</span>
              <img @click="selectOrder('现货购买T','asc')" v-if="totalTradeBuyTrx == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('现货购买T','')" v-if="totalTradeBuyTrx == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('现货购买T','desc')" v-if="totalTradeBuyTrx == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
       <el-table-column prop="totalTradeProfitTrx" label="现货收益T" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">现货收益T</span>
              <img @click="selectOrder('现货收益T','asc')" v-if="totalTradeProfitTrx == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('现货收益T','')" v-if="totalTradeProfitTrx == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('现货收益T','desc')" v-if="totalTradeProfitTrx == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column> -->
       <el-table-column prop="totalRecharge" label="累计充值USDT" width="140">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计充值USDT</span>
              <img @click="selectOrder('累积充值U','asc')" v-if="totalRecharge == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累积充值U','')" v-if="totalRecharge == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累积充值U','desc')" v-if="totalRecharge == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
       <el-table-column prop="totalWithdraw" label="累积提现U" width="140">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计提现USDT</span>
              <img @click="selectOrder('累积提现U','asc')" v-if="totalWithdraw == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累积提现U','')" v-if="totalWithdraw == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累积提现U','desc')" v-if="totalWithdraw == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <el-table-column prop="totalDayWith" label="每日提现额度" width="120" />
      <el-table-column prop="withMaxAmount" label="最高提现额度" width="120" />
      <el-table-column prop="totalRechargeUsdc" label="累积充值BTC" width="140">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计充值USDC</span>
              <img @click="selectOrder('累积充值USDC','asc')" v-if="totalRechargeUsdc == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累积充值USDC','')" v-if="totalRechargeUsdc == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累积充值USDC','desc')" v-if="totalRechargeUsdc == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <el-table-column prop="totalRechargeBtc" label="累积充值BTC" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计充值BTC</span>
              <img @click="selectOrder('累积充值BTC','asc')" v-if="totalRechargeBtc == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累积充值BTC','')" v-if="totalRechargeBtc == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累积充值BTC','desc')" v-if="totalRechargeBtc == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <el-table-column prop="totalRechargeEth" label="累积充值ETH" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计充值ETH</span>
              <img @click="selectOrder('累积充值ETH','asc')" v-if="totalRechargeEth == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累积充值ETH','')" v-if="totalRechargeEth == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累积充值ETH','desc')" v-if="totalRechargeEth == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <el-table-column prop="totalRechargeTrx" label="累积充值T" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计充值TRX</span>
              <img @click="selectOrder('累积充值T','asc')" v-if="totalRechargeTrx == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累积充值T','')" v-if="totalRechargeTrx == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累积充值T','desc')" v-if="totalRechargeTrx == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <el-table-column prop="totalRechargePol" label="累计充值POL" width="140">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计充值POL</span>
              <img @click="selectOrder('累计充值POL','asc')" v-if="totalRechargePol == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累计充值POL','')" v-if="totalRechargePol == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累计充值POL','desc')" v-if="totalRechargePol == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <el-table-column prop="totalRechargeDai" label="累计充值DAI" width="140">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计充值DAI</span> 
              <img @click="selectOrder('累计充值DAI','asc')" v-if="totalRechargeDai == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累计充值DAI','')" v-if="totalRechargeDai == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累计充值DAI','desc')" v-if="totalRechargeDai == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <!-- <el-table-column prop="totalWithdrawTrx" label="累计提现T" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计提现T</span>
              <img @click="selectOrder('累计提现T','asc')" v-if="totalWithdrawTrx == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累计提现T','')" v-if="totalWithdrawTrx == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累计提现T','desc')" v-if="totalWithdrawTrx == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column> -->
      <el-table-column prop="backendRecharge" label="累计后台充值U" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计后台充值USDT</span>
              <img @click="selectOrder('累计后台充值U','asc')" v-if="backendRecharge == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累计后台充值U','')" v-if="backendRecharge == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累计后台充值U','desc')" v-if="backendRecharge == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <!-- <el-table-column prop="backendRechargeTrx" label="累计后台充值T" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计后台充值TRX</span>
              <img @click="selectOrder('累计后台充值T','asc')" v-if="backendRechargeTrx == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累计后台充值T','')" v-if="backendRechargeTrx == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累计后台充值T','desc')" v-if="backendRechargeTrx == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column> -->
      <el-table-column prop="totalTeamProfit" label="团队累计收益U" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">团队累计收益USDT</span>
              <img @click="selectOrder('团队累计收益U','asc')" v-if="totalTeamProfit == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('团队累计收益U','')" v-if="totalTeamProfit == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('团队累计收益U','desc')" v-if="totalTeamProfit == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
      <!-- <el-table-column prop="totalTeamProfitTrx" label="团队累计收益T" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">团队累计收益T</span>
              <img @click="selectOrder('团队累计收益T','asc')" v-if="totalTeamProfitTrx == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('团队累计收益T','')" v-if="totalTeamProfitTrx == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('团队累计收益T','desc')" v-if="totalTeamProfitTrx == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column> -->
      
      
      
     
      <el-table-column prop="parentUid" label="上级UID" width="100" />
      
       <el-table-column prop="address" label="账号状态" width="100">
        <template slot-scope="scope">
          <div>
           <div v-if="scope.row.isEnabled" style="color: #06cc00">
              正常
            </div>
            <div v-if="!scope.row.isEnabled" style="color: #ff0000">
              封禁
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="platformMemo" label="老用户" width="100" />
      <el-table-column prop="WhatsApp" label="WhatsApp" width="100">
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.whatsAreaCode">
              +{{ scope.row.whatsAreaCode }}
            </div>
            <div>{{ scope.row.whatsPhone }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="lang" label="语言" width="100" />
      <el-table-column prop="yifangUsername" label="乙方" width="100" />
      <el-table-column prop="ziUid" label="携带子账号" width="100" />
      <el-table-column prop="createDate" label="创建时间" width="170" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />
    <!-- 编辑 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="500px"
      title="编辑"
      :center="true"
      :close-on-click-modal="false"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editForm" :model="active" label-width="120px">
        <el-form-item label="账号状态">
          <el-switch v-model="active.isEnabled" active-text="启用" inactive-text="封禁" @change="setIsEnabled"></el-switch>
        </el-form-item>
        <el-form-item label="是否是业务员">
          <el-switch v-model="active.isYewu" active-text="是" inactive-text="否" @change="setIsYewu"></el-switch>
        </el-form-item>
        <el-form-item label="是否能领取仓储补贴">
          <el-switch v-model="active.isSubsidy" active-text="是" inactive-text="否" @change="setIsSubsidy"></el-switch>
        </el-form-item>
        <!-- <el-form-item label="现货交易是否支持无限极分销">
          <el-switch v-model="active.isTradeLevelx" active-text="是" inactive-text="否" @change="updateIsTradeLevelx"></el-switch>
        </el-form-item> -->
        <!-- <el-form-item label="是否锁定VIP更新">
          <el-switch v-model="active.isLockVip" active-text="是" inactive-text="否" @change="updateIsLockVip"></el-switch>
        </el-form-item> -->
        <!-- <el-form-item label="非VIP可提2U">
          <el-switch v-model="active.etw" active-text="是" inactive-text="否" @change="updateEtw"></el-switch>
        </el-form-item> -->
        <el-form-item label="备注">
          <el-input v-model="active.memo" placeholder=""/>
          <el-button
          style="margin-left: 10px;"
            type="primary"
            class="edit-button"
            @click="updateMemo()"
          >更新</el-button>
        </el-form-item>
        <!-- <el-form-item label="VIP等级">
          <el-input v-model="active.vipLevel" placeholder=""/>
          <el-button
          style="margin-left: 10px;"
            type="primary"
            class="edit-button"
            @click="updateVipLevel()"
          >更新</el-button>
        </el-form-item> -->
        <el-form-item label="登录密码">
          <el-input v-model="password" placeholder=""/>
          <el-button
          style="margin-left: 10px;"
            type="primary"
            class="edit-button"
            @click="updatePassword()"
          >更新</el-button>
        </el-form-item>
        <el-form-item label="提现密码">
          <el-input v-model="withdrawPassword" placeholder=""/>
          <el-button
          style="margin-left: 10px;"
            type="primary"
            class="edit-button"
            @click="updateWithdrawPassword()"
          >更新</el-button>
        </el-form-item>
        <el-form-item label="登录解锁时间">
          <!-- <el-input v-model="active.lockDate" placeholder=""/> -->
          <el-date-picker
      v-model="lockDate"
      type="datetime"
      value-format="yyyy-MM-dd HH:mm:ss"
      placeholder="选择日期">
    </el-date-picker>
          <el-button
          style="margin-left: 10px;"
            type="primary"
            class="edit-button"
            @click="updateLockDate()"
          >更新</el-button>
        </el-form-item>
        <!-- <el-form-item label="免邮箱验证" prop="count">
          
        </el-form-item> -->
        <el-form-item label=""  style="margin-bottom: 2px;" prop="count">
          <div>免邮箱验证提现地址</div>
        </el-form-item>
        <el-form-item label="" style="margin-bottom: 5px;"  prop="count">
            <el-input v-model="address.address1" placeholder=""/>
        </el-form-item>
        <el-form-item label="" style="margin-bottom: 5px;" prop="count">
            <el-input v-model="address.address2" placeholder=""/>
        </el-form-item>
        <el-form-item label="" style="margin-bottom: 10px;" prop="count">
            <el-input v-model="address.address3" placeholder=""/>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定更新？" @confirm="updateSafeAddress()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >更新地址</el-button>
        </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :visible.sync="setIsYewuShow"
      width="500px"
      title="验证密码"
      :center="true"
      :close-on-click-modal="false"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editForm" :model="active" label-width="120px">
        <el-form-item label="">
          <el-input v-model="setIsYewuPassword" placeholder="" />
        </el-form-item>
        <el-form-item>
          <el-popconfirm v-if="type == 1" title="确定修改？" @confirm="getSetIsYewu()">
            <el-button slot="reference" type="primary" class="edit-button" >确定</el-button >
          </el-popconfirm>
          <el-popconfirm v-if="type == 2" title="确定修改？" @confirm="getSetIsSubsidy()">
            <el-button slot="reference" type="primary" class="edit-button" >确定</el-button >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible"
      width="500px"
      title="手动充值"
      :center="true"
      :close-on-click-modal="false"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editForm" :model="active" label-width="120px">
        <el-form-item label="用户UID：">
          {{active.uid}}
        </el-form-item>
        <el-form-item label="充值金额">
          <el-input v-model="amount" placeholder=""/>
        </el-form-item>
        <el-form-item label="充值密码">
          <el-input v-model="password" placeholder=""/>
        </el-form-item>
        <el-form-item label="设置">
          <el-checkbox v-model="isUnlock">计入解锁提现金额</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定充值？" @confirm="chong()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >确定</el-button>
        </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 资金明细 -->
    <el-dialog
      :visible.sync="dialogVisible1"
      width="1100px"
      title="资金明细"
      :center="true"
      :close-on-click-modal="false"
    >
     <el-table
      ref="gridTable"
      v-loading="loading"
      :data="amountList"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 940px"
      size="mini"
    >
     
      <el-table-column prop="sn" label="流水号" width="200" />
      
      <el-table-column prop="categoryStr" label="分类" width="100" />
      <el-table-column prop="subjectStr" label="抬头" width="170" />
      <el-table-column prop="amount" label="USDT金额" width="100" />
      <el-table-column prop="amountTrx" label="TRX金额" width="100" />
      <el-table-column prop="memo" label="备注" width="100" />
      <el-table-column prop="createDate" label="创建时间" width="170" />
    </el-table>
    <pagination
      :total="total1"
      :page.sync="pageNum1"
      :limit.sync="pageSize1"
      @pagination="getChonList"
    />
    </el-dialog>
    <!-- 下级团队 -->
    <el-dialog
      :visible.sync="dialogVisible2"
      width="960px"
      title="下级团队"
      :center="true"
      :close-on-click-modal="false"
    >
    <div style="font-size: 16px; font-weight: 900">所有下级统计：</div>
      <el-table
          :data="[1]"
          tooltip-effect="dark"
          :stripe="true"
          :border="true"
          style="width: 811px;margin: 5px 0;font-size: 14px;"
          size="mini"
        >
          <el-table-column prop="uid" label="注册" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.totalRegister }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="x数量" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.xxCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="非同IP注册数" width="110">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.disIpCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="vipLevel" label="投资30以上" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.xvCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="amount" label="充值USDT" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.totalRecharge }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="totalEarn" label="提现USDT" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.totalWithdraw }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="childrenCount" label="投资人数" width="100">
          <template slot-scope="scope">
              <div>{{ allChildrenSum.airdropCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="createDate" label="投资USDT" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.airdropAmount }}</div>
             </template>
          </el-table-column>
      </el-table>
        <div class="item_warp" style="margin-right: 10px;color:#000;font-weight: 900">
          今日数据：
        </div>
        <el-table
          :data="[1]"
          tooltip-effect="dark"
          :stripe="true"
          :border="true"
          style="width: 811px;margin: 5px 0;font-size: 14px;"
          size="mini"
        >
          <el-table-column prop="uid" label="注册" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayRegisterCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="x数量" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayXxCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="非同IP注册数" width="110">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayDisIpCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="vipLevel" label="投资30以上" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayXvCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="充值人数" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayRechargeCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="vipLevel" label="提现人数" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayWithdrawCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="amount" label="充值金额" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayRechargeAmount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="totalEarn" label="提现金额" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayWithdrawAmount }}</div>
             </template>
          </el-table-column>
      </el-table>
    <el-tabs v-model="level" @tab-click="handleClick">
    <el-tab-pane label="一层下级" name="1"></el-tab-pane>
    <el-tab-pane label="2-10层下级" name="2"></el-tab-pane>
   </el-tabs>
   <el-table
          :data="[1]"
          tooltip-effect="dark" 
          :stripe="true"
          :border="true"
          style="width: 811px;margin: 5px 0;font-size: 14px;"
          size="mini"
        >
          <el-table-column prop="uid" label="注册" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.totalRegister }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="x数量" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.xxCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="非同IP注册数" width="110">
            <template slot-scope="scope">
              <div>{{ childrenSum3.disIpCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="vipLevel" label="投资30以上" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.xvCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="amount" label="充值USDT" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.totalRecharge }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="totalEarn" label="提现USDT" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.totalWithdraw }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="childrenCount" label="投资人数" width="100">
          <template slot-scope="scope">
              <div>{{ childrenSum3.airdropCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="createDate" label="投资USDT" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.airdropAmount }}</div>
             </template>
          </el-table-column>
      </el-table>
        <div class="item_warp" style="margin-right: 10px;color:#000;font-weight: 900">
          今日数据：
        </div>
        <el-table
          :data="[1]"
          tooltip-effect="dark"
          :stripe="true"
          :border="true"
          style="width: 811px;margin: 5px 0 0;font-size: 14px;"
          size="mini"
        >
          <el-table-column prop="uid" label="注册" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.todayRegisterCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="x数量" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.todayXxCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="非同IP注册数" width="110">
            <template slot-scope="scope">
              <div>{{ childrenSum3.todayDisIpCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="投资30以上" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.todayXvCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="充值人数" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.todayRechargeCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="vipLevel" label="提现人数" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.todayWithdrawCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="amount" label="充值金额" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.todayRechargeAmount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="totalEarn" label="提现金额" width="100">
            <template slot-scope="scope">
              <div>{{ childrenSum3.todayWithdrawAmount }}</div>
             </template>
          </el-table-column>
      </el-table>
    <div style="margin-top: 25px;">
      <el-table
      ref="gridTable"
      v-loading="loading3" 
      :data="childrenSum2"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="540px"
      style="width: 900px"
      size="mini"
    >
    <el-table-column prop="uid" label="UID" width="100">
        <template slot-scope="scope">
          <div>
           <div>
              {{scope.row.uid}}
            </div>
            <div v-if="scope.row.isYewu" style="color: #ff0000">
              业务员
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="账号" width="100" />
      <el-table-column prop="address" label="最后登录IP" width="200">
        <template slot-scope="scope">
          <div>
            <div>{{ scope.row.lastIp }}</div>
            <div>{{ scope.row.lastIpAddress }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecharge" label="IP重复数" width="100" />
      <el-table-column prop="amount" label="余额USDT" width="100" />
      <el-table-column prop="totalProfit" label="累计收益" width="100" />
      <el-table-column prop="totalRecharge" label="累计充值USDT" width="130" />
      <el-table-column prop="totalWithdraw" label="累计提现USDT" width="130" />
      <el-table-column prop="childrenCount" label="1级团队数量" width="130" />
      <el-table-column prop="createDate" label="创建时间" width="170" />
      </el-table>
      <pagination
          :total="total2"
          :page.sync="pageNum2"
          :limit.sync="pageSize2"
          @pagination="getChildrenSumList"
        />
    </div>
    </el-dialog>

  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination, VueUeditorWrap },
  data() {
    return {
      tableData: [], // 展示的表单信息
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      total1: 0, // 总数
      pageNum1: 1, // 页码值
      pageSize1: 20, // 页大小
      loading: false, // 表格加
      uid: "",
      ip: "",
      type:"",
      yifangUsername: "",
      dataTime: ["", ""],
      username: "",
      vipStr: "",
      parentUid: "",
      ipAddress: "",
      minChildCount: "",
      isYewu: "",
      isRecharge: "",
      isEnabled: "",
      minTotalAward: "",
      active:{},
      address:{
        address1:'',
        address2:'',
        address3:''
      },
      amountList:[],
      edit_dialogVisible:false,
      dialogVisible:false,
      dialogVisible1:false,
      dialogVisible2:false,
      password:'',
      isUnlock:false,
      withdrawPassword:'',
      lockDate:'',
      amount:'',
      isLock:false,
      platformMemo:'',
      allChildrenSum:{},
      childrenSum1:[],
      childrenSum2:[],
      loading3:true,
      total2:0,
      pageNum2: 1, // 页码值
      pageSize2: 20, // 页大小
      childrenSum3:{},
      passwordTRX:'',
      amountTRX:'',
      level:'1',
      setIsYewuShow:false,
      setIsYewuPassword:'',
      // 最新
      amountOrder:'',
      amountTrxOrder:'',
      canWithdrawAmount:'',
      canWithdrawAmountTrx:'',
      totalIntelAmount:'',
      totalIntelProfit:'',
      totalInvestBuyAmountReal2:'',
      totalInvestBuyAmountRealTrx2:'',
      totalTradeBuy:'',
      totalTradeProfit:'',
      totalTradeBuyTrx:'',
      totalTradeProfitTrx:'',
      totalRecharge:'',
      totalWithdraw:'',
      totalRechargeTrx:'',
      totalWithdrawTrx:'',
      backendRecharge:'',
      backendRechargeTrx:'',
      totalTeamProfit:'',
      totalTeamProfitTrx:'',
      totalRechargeUsdc:'',
      totalRechargeBtc:'',
      totalRechargeEth:'',
      realAirdropBuyAmount:'',
      totalProfit:'',
      realAirdropWaitSaleAmount:'',
      totalRechargePol:'',
      totalRechargeDai:'',
      childrenCount:'',
      etw:false
    };
  },
  mounted() {
    this.getDate(); 
  },
  methods: {
    // 排序
    selectOrder(name,type){
      this.amountOrder=''
      this.amountTrxOrder =''

      this.canWithdrawAmount =''
      this.canWithdrawAmountTrx =''
      this.totalIntelAmount=''
      this.totalIntelProfit=''
      this.totalInvestBuyAmountReal2=''
      this.totalInvestBuyAmountRealTrx2=''
      this.totalTradeBuy=''
      this.totalTradeProfit=''
      this.totalTradeBuyTrx=''
      this.totalTradeProfitTrx=''
      this.totalRecharge=''
      this.totalWithdraw=''
      this.totalRechargeTrx=''
      this.totalWithdrawTrx=''
      this.backendRecharge=''
      this.backendRechargeTrx=''
      this.totalTeamProfit=''
      this.totalTeamProfitTrx=''
      this.totalRechargeUsdc=''
      this.totalRechargeBtc=''
      this.totalRechargeEth=''
      this.realAirdropBuyAmount=''
      this.totalProfit=''
      this.realAirdropWaitSaleAmount=''
      this.totalRechargePol=''
      this.totalRechargeDai=''
      this.childrenCount=''

      
      if(name == '下级总数'){
        this.childrenCount=type
      }
      if(name == '算力包金额'){
        this.realAirdropBuyAmount=type
      }
       if(name == '累计总收益'){
        this.totalProfit=type
      }
       if(name == '解锁中ai金额'){
        this.realAirdropWaitSaleAmount=type
      }
      if(name == '余额'){
        this.amountOrder=type
      }
      if(name == 'TRX余额'){
        this.amountTrxOrder=type
      }
      if(name == '可提现额度U'){
        this.canWithdrawAmount=type
      }
      if(name == '可提现额度T'){
        this.canWithdrawAmountTrx=type
      }
      // 
      if(name == 'EXDog余额'){
        this.totalIntelAmount=type
      }
      if(name == 'EXDOG收益'){
        this.totalIntelProfit=type
      }
      if(name == '简单赚币U'){
        this.totalInvestBuyAmountReal2=type
      }
      if(name == '简单赚币T'){
        this.totalInvestBuyAmountRealTrx2=type
      }
      if(name == '现货购买U'){
        this.totalTradeBuy=type
      }
      if(name == '现货收益U'){
        this.totalTradeProfit=type
      }
      if(name == '现货购买T'){
        this.totalTradeBuyTrx=type
      }
      if(name == '现货收益T'){
        this.totalTradeProfitTrx=type
      }
      if(name == '累积充值U'){
        this.totalRecharge=type
      }
      if(name == '累积提现U'){
        this.totalWithdraw=type
      }
      if(name == '累积充值T'){
        this.totalRechargeTrx=type
      }
      if(name == '累计提现T'){
        this.totalWithdrawTrx=type
      }
      if(name == '累计后台充值U'){
        this.backendRecharge=type
      }
      if(name == '累计后台充值T'){
        this.backendRechargeTrx=type
      }
      if(name == '团队累计收益U'){
        this.totalTeamProfit=type
      }
      if(name == '团队累计收益T'){
        this.totalTeamProfitTrx=type
      }
      if(name == '累积充值USDC'){
        this.totalRechargeUsdc=type
      }
       if(name == '累积充值BTC'){
        this.totalRechargeBtc=type
      }
      if(name == '累积充值ETH'){
        this.totalRechargeEth=type
      }
      if(name == '累计充值POL'){
        this.totalRechargePol=type
      }
      if(name == '累计充值DAI'){
        this.totalRechargeDai=type 
      }
       
     
     
      this.pageNum = 1;
      this.getList();

    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    getDate() {
      this.getList();
    },
    toTree(row){
    //   this.$router.push({ 
    //    path:'/tree',
    //    query:{
    // 	    uid:row.uid
    //     }
    //  })
    console.log(window.location.origin)
    window.open(`${window.location.origin}/gw/admin/memberTree.html?uid=${row.uid}`, '_blank');
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        uid: this.uid,
        ip: this.ip,
        yifangUsername: this.yifangUsername,
        startDate: this.dataTime[0],
        endDate: this.dataTime[1],
        username: this.username,
        vipStr: this.vipStr,
        parentUid: this.parentUid,
        ipAddress: this.ipAddress,
        minChildCount: this.minChildCount,
        isYewu: this.isYewu,
        isRecharge: this.isRecharge,
        isEnabled: this.isEnabled,
        minTotalAward: this.minTotalAward,
        amountOrder:this.amountOrder,
        amountTrxOrder:this.amountTrxOrder,
        canWithdrawAmount:this.canWithdrawAmount,
        canWithdrawAmountTrx:this.canWithdrawAmountTrx,
        totalIntelAmount:this.totalIntelAmount,
        totalIntelProfit:this.totalIntelProfit,
        totalInvestBuyAmountReal2:this.totalInvestBuyAmountReal2,
        totalInvestBuyAmountRealTrx2:this.totalInvestBuyAmountRealTrx2,
        totalTradeBuy:this.totalTradeBuy,
        totalTradeProfit:this.totalTradeProfit,
        totalTradeBuyTrx:this.totalTradeBuyTrx,
        totalTradeProfitTrx:this.totalTradeProfitTrx,
        totalRecharge:this.totalRecharge,
        totalWithdraw:this.totalWithdraw,
        totalRechargeTrx:this.totalRechargeTrx,
        totalWithdrawTrx:this.totalWithdrawTrx,
        backendRecharge:this.backendRecharge,
        backendRechargeTrx:this.backendRechargeTrx,
        totalTeamProfit:this.totalTeamProfit,
        totalTeamProfitTrx:this.totalTeamProfitTrx,
        realAirdropBuyAmount:this.realAirdropBuyAmount,
        childrenCount:this.childrenCount,
        totalProfit:this.totalProfit,
        realAirdropWaitSaleAmount:this.realAirdropWaitSaleAmount,
        isLock:this.isLock,
        platformMemo:this.platformMemo,
        etw:this.etw?1:null,
        totalRechargePol:this.totalRechargePol,
        totalRechargeDai:this.totalRechargeDai,
        totalRechargeUsdc:this.totalRechargeUsdc
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .memberList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    happenTimeFun (num) {
	let date = new Date(num);
	//时间戳为10位需*1000，时间戳为13位的话不需乘1000
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM; //月补0
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d; //天补0
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h; //小时补0
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m; //分钟补0
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s; //秒补0
	return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
},
    //编辑
    getSetIsEnabled(row){
        this.active = row
        this.password = this.active.password
        this.withdrawPassword = this.active.withdrawPassword
        this.lockDate = this.active.lockDate? this.happenTimeFun(this.active.lockDate):''
        this.active.etw =  this.active.etw == 1?true:false;
        this.edit_dialogVisible = true

    var params = {
        memberId: this.active.id
      };
      this.$api.operate
        .viewSafeAddress(params)
        .then((res) => {
            this.address.address1 = res[0]
            this.address.address2 = res[1]
            this.address.address3 = res[2]
            console.log(this.address)

        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新账号状态
    setIsEnabled(){
    var params = {
        memberId: this.active.id,
        isEnabled: this.active.isEnabled
      };
      this.$api.operate
        .setIsEnabled(params)
        .then((res) => {
          this.$message.success(res);
          this.getList()
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateEtw() {
      var params = {
        memberId: this.active.id,
        etw: this.active.etw?1:0,
      };
      this.$api.operate
        .updateEtw(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新是否是业务员
    setIsYewu() {
      if (this.active.isYewu) {
        this.getSetIsYewu();
      } else {
        this.setIsYewuShow = true;
        this.type = 1
      }
    },
    getSetIsYewu() {
      var params = {};
      if (this.active.isYewu) {
        params = {
          memberId: this.active.id,
          isYewu: this.active.isYewu
          
        };
      } else {
        params = {
          memberId: this.active.id,
          isYewu: this.active.isYewu,
          password: this.setIsYewuPassword,
        };
      }
      this.$api.operate
        .setIsYewu(params)
        .then((res) => {
          this.$message.success(res);
          this.setIsYewuShow = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setIsSubsidy() {
      var params = {};
      params = {
          memberId: this.active.id,
          isSubsidy: this.active.isSubsidy
      };
      this.$api.operate
        .setIsSubsidy(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新是否锁定VIP
    updateIsLockVip(){
    var params = {
        memberId: this.active.id,
        isLockVip: this.active.isLockVip
      };
      this.$api.operate
        .updateIsLockVip(params)
        .then((res) => {
          this.$message.success(res);
          this.getList()
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateIsTradeLevelx(){
    var params = {
        memberId: this.active.id,
        isTradeLevelx: this.active.isTradeLevelx
      };
      this.$api.operate
        .updateIsTradeLevelx(params)
        .then((res) => {
          this.$message.success(res);
          this.getList()
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新用户会员等级
    updateVipLevel() {
      var params = {
        memberId: this.active.id,
        vipLevel: this.active.vipLevel
      };
      this.$api.operate
        .updateVipLevel(params)
        .then((res) => {
          this.$message.success(res);
          this.getList()
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateMemo() {
      var params = {
        memberId: this.active.id,
        memo: this.active.memo
      };
      this.$api.operate
        .updateMemo(params)
        .then((res) => {
          this.$message.success(res);
          this.getList()
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新用户登录密码
    updatePassword() {
      var params = {
        memberId: this.active.id,
        password: this.password
      };
      this.$api.operate
        .updatePassword(params)
        .then((res) => {
          this.$message.success(res);
          this.getList()
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新用户提现密码
    updateWithdrawPassword() {
      var params = {
        memberId: this.active.id,
        withdrawPassword: this.withdrawPassword
      };
      this.$api.operate
        .updateWithdrawPassword(params)
        .then((res) => {
          this.$message.success(res);
          this.getList()
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
     updateLockDate() {
      var params = {
        memberId: this.active.id,
        lockDate: this.lockDate
      };
      this.$api.operate
        .updateLockDate(params)
        .then((res) => {
          this.$message.success(res);
          this.getList()
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 免邮箱验证提现地址
    updateSafeAddress(){
        let params = {
          memberId: this.active.id,
          ...this.address
        }
        this.$api.operate
        .updateSafeAddress(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getChong(row){
        this.active = row
        this.dialogVisible = true
        if(row.isUnlock){
          this.isUnlock = row.isUnlock
        }
        this.password = ''
        this.amount = ''
        this.amountTRX = ''
        this.passwordTRX = ''
    },
    // 手动充值
    chong(){
       var params = {
        memberId: this.active.id,
        amount: this.amount,
        password: this.password,
        isUnlock: this.isUnlock
      };
      this.$api.operate
        .chong(params)
        .then((res) => {
          this.$message.success(res);
          this.dialogVisible = false
          this.getList()
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 手动充值
    chongTrx(){
       var params = {
        memberId: this.active.id,
        amount: this.amountTRX,
        password: this.passwordTRX
      };
      this.$api.operate
        .chongTrx(params)
        .then((res) => {
          this.$message.success(res);
          this.dialogVisible = false
          this.getList()
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getZiJin(row){
        this.active = row
        this.getChonList()
    },
    getChonList(){
         var params = {
        memberId: this.active.id,
        pageNumber: this.pageNum1,
        pageSize: this.pageSize1,

      };
      this.$api.operate
        .amountList(params)
        .then((res) => {
          this.amountList = res.records;
        this.dialogVisible1 = true
          this.total1 = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });

    },
    getChildrenSum(row){
        this.active = row
        this.dialogVisible2 = true
        this.totalRechargeTrx1 =''
        this.totalWithdrawTrx1 =''
        this.$api.operate
        .allChildrenSum({
            memberId: this.active.id
        })
        .then((res) => {
            this.allChildrenSum = res
          
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
        this.childrenSum()
    },
    childrenSum(){
         this.$api.operate
        .childrenSum({
            memberId: this.active.id,
            level:this.level
        })
        .then((res) => {
            this.childrenSum3 = res
          
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
        // 
        this.getChildrenSumList()
    },
    getChildrenSumList(){
      this.loading3 = true
      this.$api.operate
        .children({
            memberId: this.active.id,
            level:this.level,
            totalRechargeTrx:this.totalRechargeTrx1,
            totalWithdrawTrx:this.totalWithdrawTrx1,
            pageNumber: this.pageNum2,
          pageSize: this.pageSize2,
        })
        .then((res) => {
            this.childrenSum2 = res.records
            this.total2 = res.total;

        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading3 = false;
        });

    },
    handleClick(){
        console.log(this.level)
        this.childrenSum()
    },



  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
  
}
.flex{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
